import React from 'react';
import {
  Header,
  SwapCard,
  ConfirmMaxModal,
  NetworkSwitchModal,
  DiagnosticsPane,
  AppVersionBadge,
  Footer,
} from './components';
import { useSwapController } from './hooks/useSwapController';
import './styles.css';

function App() {
  const {
    // Chain config & selector
    enabledChains,
    comingSoonChains,
    selectedChainKey,
    selectedChain,
    isChainMenuOpen,
    setIsChainMenuOpen,
    handleChainSelect,
    networkDisplayName,

    // Token & Balances
    selectedStablecoin,
    selectedCoin,
    balanceLabel,
    stablecoinBalance,
    usdnBalance,
    stablecoinLoading,
    usdnLoading,

    // Form inputs & Validation
    amount,
    amountValidation,
    handleAmountChange,
    handleStablecoinSelect,

    // Wallet state & actions
    address,
    isConnected,
    isWalletNetworkAligned,
    currentNetworkName,
    connectButtonText,
    disconnect,
    toggleTargetNetworkName,
    copyFeedback,
    handleCopyAddress,
    handleConnect,
    handleSwitchNetwork,

    // Swap actions & state
    capabilities,
    allowanceEnough,
    isLoading,
    isSwapButtonDisabled,
    getButtonText,
    chainReadinessMessage,
    status,
    statusType,
    transactionHash,
    pendingSwapHash,
    pendingSwapClearLabel,
    handleClearPendingSwap,
    handleConnectOrSwap,

    // Modals
    showMaxModal,
    setShowMaxModal,
    handleConfirmMax,
    isNetworkSwitchModalOpen,
    handleCloseNetworkSwitchModal,

    // Diagnostics
    diagnostics,
  } = useSwapController();

  return (
    <div className="app">
      <ConfirmMaxModal
        isOpen={showMaxModal}
        onClose={() => setShowMaxModal(false)}
        onConfirm={handleConfirmMax}
        tokenName={selectedCoin?.name || 'token'}
        balance={stablecoinBalance}
      />

      <NetworkSwitchModal
        isOpen={isNetworkSwitchModalOpen}
        onClose={handleCloseNetworkSwitchModal}
        onConfirm={handleSwitchNetwork}
        currentNetworkName={currentNetworkName}
        targetChain={selectedChain}
        isLoading={isLoading}
      />

      <Header
        chains={enabledChains}
        comingSoonChains={comingSoonChains}
        selectedChainKey={selectedChainKey}
        selectedChain={selectedChain}
        isChainMenuOpen={isChainMenuOpen}
        onToggleChainMenu={() => setIsChainMenuOpen(prev => !prev)}
        onCloseChainMenu={() => setIsChainMenuOpen(false)}
        onSelectChain={handleChainSelect}
        isConnected={isConnected}
        isWalletNetworkAligned={isWalletNetworkAligned}
        networkDisplayName={networkDisplayName}
        address={address}
        connectButtonText={connectButtonText}
        onConnect={handleConnect}
        onDisconnect={disconnect}
        onCopyAddress={handleCopyAddress}
        copyFeedback={copyFeedback}
        isDebugMode={diagnostics.isDebugMode}
        toggleTargetNetworkName={toggleTargetNetworkName}
        onSwitchNetwork={handleSwitchNetwork}
      />

      <SwapCard
        selectedStablecoin={selectedStablecoin}
        onSelectStablecoin={handleStablecoinSelect}
        stablecoins={selectedChain?.stablecoins || {}}
        stablecoinBalance={stablecoinBalance}
        usdnBalance={usdnBalance}
        balanceLabel={balanceLabel}
        amount={amount}
        onAmountChange={handleAmountChange}
        inputError={amountValidation.error}
        isConnected={isConnected}
        onMaxClick={() => setShowMaxModal(true)}
        stablecoinLoading={stablecoinLoading}
        usdnLoading={usdnLoading}
        isWalletNetworkAligned={isWalletNetworkAligned}
        selectedChainKey={selectedChainKey}
        selectedChain={selectedChain}
        chainReadinessMessage={chainReadinessMessage}
        capabilities={capabilities}
        allowanceEnough={allowanceEnough}
        isLoading={isLoading}
        isDisabled={isSwapButtonDisabled}
        buttonText={getButtonText()}
        onConnectOrSwap={handleConnectOrSwap}
        status={status}
        statusType={statusType}
        transactionHash={transactionHash}
        pendingSwapHash={pendingSwapHash}
        pendingSwapClearLabel={pendingSwapClearLabel}
        onClearPendingSwap={handleClearPendingSwap}
      />

      <Footer />

      <DiagnosticsPane
        isDiagnosticsMode={diagnostics.isDiagnosticsMode}
        diagnosticsRows={diagnostics.diagnosticsRows}
        onPopout={diagnostics.handleOpenDiagnosticsWindow}
      />

      <AppVersionBadge />
    </div>
  );
}

export default App;
